/* istanbul ignore file */
export * from './InstallmentCalulatorInDialog';
